<template>
  <div id="app">
    <div><helloWorld /></div>
  </div>
</template>

<script>
import helloWorld from './components/HelloWorld'
export default {
  name: "App",
  components:{
    helloWorld
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 60px;
  background: #fafafa;
}
</style>



// WEBPACK FOOTER //
// src/App.vue